<template>
  <main class="container-fluid mt-3 bg-white">
    <div class="row h-100 no-gutters pt-5">
      <div class="col-12 mx-lg-auto p-0">
        <div
        class="row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
        >
        <div class="col-12 col-xl-2 col-md-3 pt-lg-6 border-right">
            <pc-side-nav/>
          </div>

          <div class="col-12 col-lg mb-3 mb-lg-5 pt-6">
            <pc-my-projects-conatiner :isAdmin = "user.isAdmin" class="pc-my-trays-pages" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PcMyProjectsConatiner from "./pc-my-projects-container.vue";
import PcSideNav from "../my-trays-page/pc-side-nav.vue";

export default {
  props:['user'],
  components: {
    PcMyProjectsConatiner,
    PcSideNav
  },
  methods: {
    ...mapActions({
      updateCommonErrorMsg:"myTray/updateCommonErrorMsg",
      myProjectCommonErrorMsg:"myProject/myProjectCommonErrorMsg",
      basketTitleUpdate:"myProject/basketTitleUpdate",
      basketCommonErrorMsg:"myProject/basketCommonErrorMsg",
    }),
  },
  mounted(){
    this.updateCommonErrorMsg(this.$resourceString["common.Error.Msg"]);
    this.myProjectCommonErrorMsg(this.$resourceString["common.Error.Msg"]);
    this.basketTitleUpdate(this.$resourceString["virtualtray.basket.updated.title"]);
    this.basketCommonErrorMsg(this.$resourceString["common.CartAlert.ErrorMsg"]);
  }
};
</script>
